import React from 'react';

const InProgressBadge = () => (
  <span className="px-2 py-0.5 rounded text-xs font-medium" style={{ color: '#556B2F', background: '#E6F4D7' }}>
    In-Progress
  </span>
);

export default InProgressBadge;
